var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-5" },
    [
      _c(
        "div",
        { staticClass: "bg-white" },
        [
          _vm.checkRoles(["terminal"])
            ? _c(
                "div",
                { staticClass: "p-5" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-plus",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.setDialog()
                        },
                      },
                    },
                    [_vm._v("添加广告位置")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                data: _vm.list,
                "element-loading-text": "Loading",
                stripe: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "广告位置" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.position_type))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "广告位置名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("div", [_vm._v(_vm._s(scope.row.ad_des))])]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "广告类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(_vm._s(_vm.adType[scope.row.ad_type])),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _vm.checkRoles(["partner"])
                ? _c("el-table-column", {
                    attrs: { label: "微信广告ID" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(scope.row.wx_ad_id || "--")),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2911153430
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.checkRoles(["partner"])
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  round: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.setShow(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.is_show == 1 ? "已开启" : "已关闭"
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkRoles(["partner"])
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  round: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.adUnitId(scope.row)
                                  },
                                },
                              },
                              [_vm._v("设置广告ID")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkRoles(["terminal"])
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  round: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.setDialog(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.checkRoles(["terminal"])
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  round: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.delAd(scope.row, scope.$index)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "编辑广告位置", visible: _vm.adDialog },
          on: {
            "update:visible": function ($event) {
              _vm.adDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "130px" } },
            [
              _c("el-form-item", { attrs: { label: "广告类型:" } }, [
                _c("div", [_vm._v(_vm._s(_vm.business_des))]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "广告位置:" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "如:1" },
                    model: {
                      value: _vm.form.position_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "position_type", $$v)
                      },
                      expression: "form.position_type",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "广告位置名称:" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "如:首页插屏广告" },
                    model: {
                      value: _vm.form.ad_des,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "ad_des", $$v)
                      },
                      expression: "form.ad_des",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "广告类型:" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.ad_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "ad_type", $$v)
                        },
                        expression: "form.ad_type",
                      },
                    },
                    _vm._l(_vm.adType, function (item, index) {
                      return _c("el-option", {
                        attrs: { label: item, value: index },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.adDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.clickSubmit },
                  on: {
                    click: function ($event) {
                      return _vm.postAdd()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.clickSubmit ? "提交中" : "确 定"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }